import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DataGridFlexSales, useDataGridFlexSales, useDataGridSync } from '../DataGridFlexSales';

import { reportFilterCountryCodeSelector, reportPendingInterfacesSalesSelector } from '../../state';
import { PendingInterfaces } from '../../types';
import handlerFactory, { PendingInterfacesDataGridContext } from './handlerFactory';

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<PendingInterfaces, PendingInterfacesDataGridContext>();

  const { t } = useTranslation();
  const title = t('pending-interfaces.titles.principal');
  const country = useSelector(reportFilterCountryCodeSelector);
  const salesResource = useSelector(reportPendingInterfacesSalesSelector);
  const { data, loading } = salesResource;

  const gridContext = useMemo(
    () => ({
      t,
      country,
    }),
    [t, country]
  );

  useDataGridSync({
    handler,
    data,
    context: gridContext,
    title,
    loading,
  });

  return null;
};

const PendingInterfacesDataGrid = () => (
  <DataGridFlexSales handlerFactory={handlerFactory}>
    <DataGridConfig />
  </DataGridFlexSales>
);

export default PendingInterfacesDataGrid;
